/* Component Dependencies */
var travelInsuranceStaticBannerTemplate = require('templates/travelInsuranceStaticBanner.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'travelInsuranceStaticBanner',
  template: {
    'travelInsuranceStaticBanner': travelInsuranceStaticBannerTemplate
  },
  subscribe: {
    'REFRESH_ORG_BOOKING_DETAILS': 'updateTile'
  },
  bindEvents: function () {
    if ($(".tile-travel-insurance-static-banner").length > 0) {
      window.impressionTrack("Banner|upcomingRes|external|event168|list3=InsuranceBanner,type=insurance,msg=travelInsurance0921,tag=US-");
    }
  },
  updateTile: function _updateTile() {
   var _self = this;
   _self.refresh();
  }
});
